module.exports = __webpack_public_path__ + "img/offer.6037f771.png";